import { render } from "./MainHeaderComponent.vue?vue&type=template&id=38f800e1&scoped=true"
import script from "./MainHeaderComponent.vue?vue&type=script&lang=js"
export * from "./MainHeaderComponent.vue?vue&type=script&lang=js"

import "./MainHeaderComponent.vue?vue&type=style&index=0&id=38f800e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f800e1"]])

export default __exports__